import { DeleteWorkspaceSuccess } from './components/delete-workspace-success';

export function WorkspaceDeleteSuccessView() {
  return <DeleteWorkspaceSuccess />;
}
